import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectCurrentError } from 'src/app/store/mbcc/mbcc.selectors';

import { AppError } from './app-error.interface';
import { appErrorMajor, appErrorMinorLoading } from './store/app-error.actions';

@Injectable({
  providedIn: 'root'
})
export class AppErrorService {
  public constructor(private readonly store: Store) {}

  public get currentError$(): Observable<AppError> {
    return this.store.pipe(selectCurrentError);
  }

  public handleMajorError(currentError: AppError): void {
    this.store.dispatch(appErrorMajor({ error: currentError }));
  }

  /**
   * Minor loading errors should be displayed if, something can not be loaded, but the application can go on. For example "matrix-detail-data" or "motor-transfer-config data"
   *
   * @param error - the error response from the Backend
   */
  public handleMinorLoadingError(error: HttpErrorResponse): void {
    this.store.dispatch(appErrorMinorLoading({ error }));
  }
}
